export const requiredParametersTheme = {
  drag: {
    bg: 'palette.tertiary.0',
    border: 'palette.surface.4',
    text: 'palette.tertiary.80',
  },
  error: 'palette.error.60',
  info: {
    bg: 'palette.primary.30',
    borderRadius: '8px',
    text: 'palette.primary.95',
  },
};
